export default __webpack_public_path__ + "static/media/loop3.8b9bbf79.png";